/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { HeadcountRollup } from './HeadcountRollup';
import type { WireframeReportPerson } from './WireframeReportPerson';
import type { WireframeReportProfile } from './WireframeReportProfile';
import type { WireframeReportSpend } from './WireframeReportSpend';

export type WireframeReportRow = {
    workstream_id: number;
    name: string;
    depth: number;
    parent_workstream_id: (number | null);
    source: WireframeReportRow.source;
    ignores_entered_input: boolean;
    headcount: HeadcountRollup;
    spend: WireframeReportSpend;
    pillar_share: (string | null);
    company_share: (string | null);
    profile: (WireframeReportProfile | null);
    dris: Array<WireframeReportPerson>;
};

export namespace WireframeReportRow {

    export enum source {
        INPUT = 'input',
        ROLLUP = 'rollup',
        NONE = 'none',
    }


}

